document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', () => {
    return {
      footerRoot: null,
      _applyDrawerFooterBorder() {
        const cartDrawerFooter = this.footerRoot?.closest('.pt-5.pb-safe-bottom.relative.px-section');
        if (!cartDrawerFooter) return;
        const hasBorderEl = !!cartDrawerFooter.querySelector('.border-t-section.border-scheme-text');
        cartDrawerFooter.style.borderTop = hasBorderEl ? '' : 'none';
      },
      _morphFooter(e) {
        const sections = e.detail?.response?.sections;
        const cartFooterHtml = sections?.['cart-footer'];
        if (!cartFooterHtml) return;
        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          cartFooterHtml
        );
        if (!newFooterSection) return;
        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );
        this.$nextTick(() => this._applyDrawerFooterBorder());
      },
      init() {
        this.footerRoot = this.$root;

        window.addEventListener('shapes:modalcart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          this._morphFooter(e);
        });

        this.$nextTick(() => this._applyDrawerFooterBorder());
      },
    };
  });
});
